export default __webpack_public_path__ + "images/Graph.v-bf4c9b471cf008333d11b2945ea3ae7a.png";